import { Settings02Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import {
    Box,
    Button,
    Card,
    CardActions,
    CardContent,
    Chip,
    Stack,
    Typography,
} from "@mui/material";

type Props = {
    title: string;
    description?: string;
    isPublished?: boolean;
    status?: string;
    onClick: () => void;
    onSettingsClick?: () => void;
    primaryActionLabel?: string;
    createdBy?: string;
    lastUpdatedAt?: number;
};

const MenuCard = ({
    title,
    description,
    isPublished,
    status,
    onClick,
    onSettingsClick,
    primaryActionLabel = "Ver",
}: Props) => {
    const isPublishedStatus =
        typeof isPublished === "boolean"
            ? isPublished
            : status === "published" || status === "active";

    const chipConfig = isPublishedStatus
        ? { label: "Publicado", color: "success" as const }
        : { label: "Borrador", color: "default" as const };

    return (
        <Card
            sx={{
                borderRadius: 3,
                overflow: "hidden",
                height: "100%",
                display: "flex",
                flexDirection: "column",
            }}
        >
            {/* Card Header con fondo azul de la marca y padding de 24px (16px inferior) */}
            <Box
                sx={{
                    bgcolor: "#06175D",
                    color: "common.white",
                    pt: "24px",
                    px: "24px",
                    pb: "16px",
                }}
            >
                <Stack spacing={5}>
                    <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <Chip
                            size="small"
                            color={chipConfig.color}
                            label={chipConfig.label}
                            sx={
                                !isPublishedStatus
                                    ? {
                                        bgcolor: "rgba(255, 255, 255, 0.2)",
                                        color: "common.white",
                                    }
                                    : undefined
                            }
                        />
                    </Stack>

                    <Typography
                        variant="h3"
                        sx={{
                            color: "common.white",
                        }}
                    >
                        {title}
                    </Typography>
                </Stack>
            </Box>

            {/* Cuerpo de la tarjeta y acciones con padding de 24px (16px superior) */}
            <Stack
                sx={{
                    pt: "16px",
                    px: "24px",
                    pb: "24px",
                    flex: 1,
                    justifyContent: "space-between",
                }}
                spacing={3}
            >
                <CardContent sx={{ p: 0, "&:last-child": { pb: 0 } }}>
                    <Typography variant="body2">
                        {description || "Sin descripción configurada."}
                    </Typography>
                </CardContent>

                <CardActions sx={{ p: 0, justifyContent: "flex-start", gap: 0.5 }}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={onClick}
                    >
                        {primaryActionLabel}
                    </Button>
                    {onSettingsClick && (
                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={onSettingsClick}
                            sx={{ minWidth: "auto", px: 1.5 }}
                            aria-label="Configuración"
                        >
                            Editar
                        </Button>
                    )}
                </CardActions>
            </Stack>
        </Card>
    );
};

export default MenuCard;
